// import { createMuiTheme } from "@mui/material/styles";
// import { createTheme } from "@mui/material/styles";
import { createTheme } from "@mui/material/styles";
import {
  isUnity,
  isEldBooks,
  isBluehorse,
  isVulcansols,
  isRadical,
  isApex,
  isEldNN,
  isSt,
  isTe,
  isEt,
  isSaferEld
} from "../configureStore";

const BTN_COLOR = "#009be5";
const BTN_COLOR_UNITY = "#006db3";
const BTN_COLOR_EB = "#0f0047";
const BTN_COLOR_BH = "#253b98";
const BTN_COLOR_VS = "#000000";
const BTN_COLOR_RE = "#000000";
const BTN_COLOR_AU = "#3b2f65";
const BTN_COLOR_NN = "#0f0047";
const BTN_COLOR_ST = "#0f0047";
const BTN_COLOR_TE = "#3aa6cc";
const BTN_COLOR_ER = "#1800ac";
const BTN_COLOR_SA = "#1e8894";

const BTN_DARK_COLOR = "#006db3";
const BTN_DARK_COLOR_UNITY = "#006db3";
const BTN_DARK_COLOR_EB = "#006db3";
const BTN_DARK_COLOR_BH = "#006db3";
const BTN_DARK_COLOR_VS = "#006db3";
const BTN_DARK_COLOR_RE = "#000000";
const BTN_DARK_COLOR_AU = "#3b2f65";
const BTN_DARK_COLOR_NN = "#006db3";
const BTN_DARK_COLOR_ST = "#006db3";
const BTN_DARK_COLOR_TE = "#1c5482";
const BTN_DARK_COLOR_ER = "#110361";
const BTN_DARK_COLOR_SA = "#1e8894";

let theme = createTheme({
  typography: {
    useNextVariants: true,
    fontFamily: "sans-serif",
    h5: {
      fontWeight: 500,
      fontSize: 26,
      letterSpacing: 0.5,
    },
  },
  palette: {
    primary: {
      light: "#63ccff",
      main: isUnity
        ? BTN_COLOR_UNITY
        : isEldBooks
        ? BTN_COLOR_EB
        : isBluehorse
        ? BTN_COLOR_BH
        : isVulcansols
        ? BTN_COLOR_VS
        : isRadical
        ? BTN_COLOR_RE
        : isApex
        ? BTN_COLOR_AU
        : isEldNN
        ? BTN_COLOR_NN
        : isSt
        ? BTN_COLOR_ST
        : isTe
        ? BTN_COLOR_TE
        : isEt
        ? BTN_COLOR_ER
        : isSaferEld
        ? BTN_COLOR_SA
        : BTN_COLOR,
      dark: isUnity
        ? BTN_DARK_COLOR_UNITY
        : isEldBooks
        ? BTN_DARK_COLOR_EB
        : isBluehorse
        ? BTN_DARK_COLOR_BH
        : isVulcansols
        ? BTN_DARK_COLOR_VS
        : isRadical
        ? BTN_DARK_COLOR_RE
        : isApex
        ? BTN_DARK_COLOR_AU
        : isEldNN
        ? BTN_DARK_COLOR_NN
        : isSt
        ? BTN_DARK_COLOR_NN
        : isSt
        ? BTN_DARK_COLOR_ST
        : isTe
        ? BTN_DARK_COLOR_TE
        : isEt
        ? BTN_DARK_COLOR_ER
        : isSaferEld
        ? BTN_DARK_COLOR_SA
        : BTN_DARK_COLOR,
    },
  },
  shape: {
    borderRadius: 8,
  },
});

theme = {
  ...theme,
  overrides: {
    MuiDrawer: {
      paper: {
        backgroundColor: "#fafbfc",
      },
    },
    MuiButton: {
      label: {
        textTransform: "initial",
      },
      contained: {
        boxShadow: "none",
        "&:active": {
          boxShadow: "none",
        },
      },
    },
    MuiTabs: {
      root: {
        marginLeft: theme.spacing(1),
      },
      indicator: {
        height: 3,
        borderTopLeftRadius: 3,
        borderTopRightRadius: 3,
        backgroundColor: theme.palette.common.white,
      },
    },
    MuiTab: {
      root: {
        textTransform: "initial",
        margin: "0 16px",
        minWidth: 0,
        [theme.breakpoints.up("md")]: {
          minWidth: 0,
        },
      },
      // labelContainer: {
      //     padding: 0,
      //     [theme.breakpoints.up("md")]: {
      //         padding: 0
      //     }
      // }
    },
    MuiIconButton: {
      root: {
        padding: theme.spacing(1),
      },
    },
    MuiTooltip: {
      tooltip: {
        borderRadius: 4,
      },
    },
    MuiDivider: {
      root: {
        backgroundColor: "#404854",
      },
    },
    MuiListItemText: {
      primary: {
        fontWeight: theme.typography.fontWeightMedium,
      },
    },
    MuiListItemIcon: {
      root: {
        color: "inherit",
        marginRight: 0,
        "& svg": {
          fontSize: 20,
        },
      },
    },
    MuiAvatar: {
      root: {
        width: 32,
        height: 32,
      },
    },
  },
  props: {
    MuiTab: {
      disableRipple: true,
    },
  },
  mixins: {
    ...theme.mixins,
    toolbar: {
      minHeight: 48,
    },
  },
};

export default theme;
